import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeAttributionMarcheLot } from '../models/TypeAttributionMarcheLot';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { Step5 } from '../../../../shared/models/component-messages/diveAT/step5';

@Component({
  selector: 'app-type-attribution-marche-lot',
  templateUrl: './type-attribution-marche-lot.component.html'
})
export class TypeAttributionMarcheLotComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() attribue: TypeAttributionMarcheLot;
  @Input() errorMessagePersonneMoral: string;
  @Input() type: string;
  @Input() index = 0;
  public current_uid = '_SepSep_TypeAttributionMarcheLot';

  public step5 = new Step5();
  public radioButtonCtrlName: string;
  public checkboxCtrlName: string;

  constructor() {
  }

  public ngOnInit() {
    this.radioButtonCtrlName = this.getUid() + '_SepAtt_sousTraitanceNon';
    this.checkboxCtrlName = this.getUid() + '_SepAtt_montantIndefini';
  }

  public getUid() {
    return this.uid + this.current_uid;
  }

  public getUidTypeMontant() {
    return this.getUid() + '_SepSep_TypeMontant';
  }

  public isMontantDefini(): boolean {
    return !this.parentForm.controls[this.checkboxCtrlName]?.value;
  }

  public isSousTraitance(): boolean {
    return this.parentForm.controls[this.radioButtonCtrlName].value;
  }

  public isLotAttribue() {
    return this.type !== RadioCheckBoxEnum.infructueux && this.type !== RadioCheckBoxEnum.sansSuite;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }
}
